import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量读取
  timeout: 15000, // 请求超时时间
  headers: {
    // 'Content-Type': 'application/json;charset=utf-8'
    'Content-Type': 'multipart/form-data'
  }
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示 loading
    if (config.showLoading !== false) {
      // 这里可以添加全局 loading
    }

    // 添加 token
    // const token = store.getters.token
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`
    // }

    // 序列化参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const key in config.params) {
        if (config.params[key] !== null && config.params[key] !== undefined) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    console.log(JSON.stringify(config.headers))

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 隐藏 loading
    // ...

    const res = response.data

    // 这里根据后端返回的数据结构进行调整
    if (res.code !== 200) {
      // 处理业务错误
      console.log(res.message)
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    // 隐藏 loading
    // ...

    // HTTP 状态码错误处理
    if (error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请重新登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          error.message = `连接错误${error.response.status}`
      }
    } else if (error.request) {
      error.message = '网络连接异常'
    } else {
      error.message = error.message
    }
    console.log(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js